import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import logoLight from "../../assets/images/buyers-club.png";
import bcrypt from "bcryptjs-react";
//formik
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { passwordSet } from "../../slices/thunks";

const SetPassword = (props) => {
  document.title = `Set Password | ${process.env.REACT_APP_SITE_TITLE}`;

  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Please enter your password"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords do not match")
        .required("Please confirm your password"),
    }),
    onSubmit: (values) => {
      var data = {
        token: searchParams.get("token"),
        password: bcrypt.hashSync(values.password, 10),
      };
      dispatch(passwordSet(data, props.router.navigate));
    },
  });

  return (
    <div className="auth-page-content">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="text-center mt-sm-5 mb-4 text-white-50">
              <div>
                <Link to="/#" className="d-inline-block auth-logo">
                  <img src={logoLight} alt="" height="200" />
                </Link>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="mt-4">
              <CardBody className="p-4">
                <div className="text-center mt-2">
                  <h5 className="text-primary">Complete Your Account Setup</h5>
                  <p className="text-muted">
                    Set your password to activate your {process.env.REACT_APP_SITE_TITLE} account
                  </p>

                  <lord-icon
                    src="https://cdn.lordicon.com/xzybfbcm.json"
                    trigger="loop"
                    colors="primary:#0ab39c"
                    className="avatar-xl"
                    style={{ width: "120px", height: "120px" }}
                  ></lord-icon>
                </div>

                <Alert
                  className="border-0 alert-warning text-center mb-2 mx-2"
                  role="alert"
                >
                  Create a secure password to complete your registration!
                </Alert>
                <div className="p-2">
                  <Form onSubmit={validation.handleSubmit}>
                    <div className="mb-3">
                      <Label htmlFor="userpassword" className="form-label">
                        Password <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Enter Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password &&
                      validation.errors.password ? (
                        <FormFeedback type="invalid">
                          <div>{validation.errors.password}</div>
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-2">
                      <Label htmlFor="confirmPassword" className="form-label">
                        Confirm Password <span className="text-danger">*</span>
                      </Label>
                      <Input
                        name="confirm_password"
                        type="password"
                        placeholder="Confirm Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.confirm_password || ""}
                        invalid={
                          validation.touched.confirm_password &&
                          validation.errors.confirm_password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.confirm_password &&
                      validation.errors.confirm_password ? (
                        <FormFeedback type="invalid">
                          <div>{validation.errors.confirm_password}</div>
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="text-center mt-4">
                      <button className="btn btn-success w-100" type="submit">
                        Set Password & Continue
                      </button>
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>

            <div className="mt-4 text-center">
              <p className="mb-0">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="fw-bold text-primary text-decoration-underline"
                >
                  {" "}
                  Sign in{" "}
                </Link>{" "}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(SetPassword);
